<template>
  <div
    style="
      background-image: url('/images/ourGlobal.png');
      background-size: cover;
      background-position: center;
      background-repeat: no-repeat;
      min-height: 900px;
    "
  >
    .
    <div style="margin-top: 120px">
      <Global />
    </div>
  </div>
</template>

<script setup>
import { onMounted } from "vue";
import Global from "@/components/GetTouch/Global.vue";

onMounted(() => {
  window.scrollTo({ top: 0, behavior: "smooth" });
});
</script>
